import { API_ENDPOINTS } from "./apiEndpoints";

export interface StopFindTaxeZone {
  Id: number;
  Name: string;
  TypeAsString: string | null;
}

export interface StopFindResult {
  Id: number;
  OgtStopUrlSegment: string;
  IsCityStop: boolean;
  TaxeZone: StopFindTaxeZone | null;
  PlaceName: string;
  Ll: [number, number];
  FsType: string;
  OgtType: string;
}

export async function findStops(
  q: string,
  pointType: "stop" = "stop"
): Promise<StopFindResult[]> {
  const url = `${API_ENDPOINTS.POINTS_FIND}?q=${encodeURIComponent(
    q
  )}&pointType=${encodeURIComponent(pointType)}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json, text/javascript, */*; q=0.01",
    },
  });

  if (!res.ok) {
    console.error(
      "Points/Find error",
      res.status,
      await res.text().catch(() => "")
    );
    return [];
  }

  const data = (await res.json()) as StopFindResult[] | null;
  if (!Array.isArray(data)) return [];
  return data;
}
